import React from 'react';
import { Link } from 'react-router-dom';

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <Link to="/login" className="auth-brand">
          <span className="auth-brand__cm">CerebralMachines</span>
          <span className="auth-brand__dm">Denial Management</span>
        </Link>
        <h1 className="auth-title">{title}</h1>
        {subtitle && <p className="auth-subtitle">{subtitle}</p>}
        {children}
        {footer && <div className="auth-footer">{footer}</div>}
        <div className="auth-legal">
          <Link to="/terms" className="auth-legal__link">Terms of Use</Link>
        </div>
      </div>
      <div className="auth-aside">
        <h2>Recover denied claims, automatically.</h2>
        <p>
          Upload a denial pack, let the 12-component Denial Recovery Engine build
          the appeal, and track expected recovery across every facility.
        </p>
        <ul>
          <li>Evidence-grounded appeal letters with policy crosswalks</li>
          <li>Auto-approve vs. human-review routing by confidence</li>
          <li>Win-rate priors and recovery analytics per payer</li>
        </ul>
      </div>
    </div>
  );
}
